import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

/**
 * Component IDs (ordering priority) for the document search header left-side registry.
 * Start with explicit names; consumers can extend this enum when registering.
 */
enum DocumentSearchLeftComponentId {
    // Reserve first slot for custom components (e.g., filters toggles, statistics badges)
    OntarioMdHealthReportManager_PullingErrorNotice = 0
}

/**
 * Props passed to each registered left-side component.
 * Extend as needed when more context is required by extensions.
 */
interface IDocumentSearchLeftComponentRegistryProps {
    documentsModel: any; // Immutable model passed from DocumentSearch; kept as any to avoid tight coupling.
}

/**
 * Registry responsible for rendering additional components next to the title
 * in the DocumentSearch header (`additionalLeftComponent`).
 */
class DocumentSearchLeftComponentRegistry extends BaseComponentRegistry<DocumentSearchLeftComponentId, IDocumentSearchLeftComponentRegistryProps> {}

/**
 * React view that renders all registered left-side header components.
 */
const DocumentSearchLeftComponentRegistryView = createRegistryListView(() => DocumentSearchLeftComponentRegistry.getInstance());

export {
    DocumentSearchLeftComponentId,
    DocumentSearchLeftComponentRegistry,
    DocumentSearchLeftComponentRegistryView,
    IDocumentSearchLeftComponentRegistryProps
};
